<template>
  <div class="modal overflow-auto">
    <div class="card inner">
      <div class="header">
        <div class="title">
          <h2>Edit Security Details</h2>
        </div>
        <div class="close" @click="close()">
          <i class="icn icn-x sm"></i>
        </div>
      </div>
      <div class="content">
        <form id="user-security" @submit.prevent @submit="edit">
          <h3 class="sub-title">Access</h3>
          <div class="row mt-2">
            <div class="field">
              <Toggle ref="toggleEnable" label="Account Enabled" :default="item.isEnabled"></Toggle>
            </div>
            <div class="field" v-if="canEditSuperAdmin">
              <Toggle ref="toggleAdmin" label="Is super admin" :default="item.isSuperAdmin"></Toggle>
            </div>
          </div>
          <h3 class="sub-title">Password</h3>
          <div class="row mt-2">
            <div class="field">
              <input
                v-model="editItem.password"
                type="text"
                placeholder="New Password"
                maxlength="127"
                minlength="6"
                autocomplete="nope"
              />
            </div>
          </div>
        </form>
      </div>

      <!-- Error Messages -->
      <Alert v-if="errorMessage" :message="errorMessage"></Alert>
      <Alert v-if="couldEditSuperAdmin" :message="infoMessage"></Alert>

      <div class="footer">
        <button class="secondary" type="button" @click="close()">Cancel</button>
        <div class="flex-grow"></div>
        <button type="button" @click="edit()">
          <span v-if="!isValidating">Save</span>
          <span class="icon" v-if="isValidating">
            <i class="icn icn-refresh sm animate-reverse-spin"></i>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ALERT_TYPE, MESSAGES } from '@/helpers/constants';
import { MODAL_NAME } from '../store';
import Alert from '@/components/Alert.vue';
import Toggle from '@/components/Toggle';

export default {
  name: 'UserEditSecurityDetails',
  components: {
    Alert,
    Toggle,
  },

  data() {
    return {
      editItem: {
        password: 'null',
        isEnabled: true,
        isSuperAdmin: false,
      },
      isValidating: false,
      message: null,
      infoMessage: {
        content: 'You cannot change your own Super Admin status.',
        type: ALERT_TYPE.INFO,
      },
    };
  },
  computed: {
    item() {
      return this.$store.getters['users/getUser'];
    },
    currentUser() {
      return this.$store.getters['auth/currentUser'];
    },
    canEditSuperAdmin() {
      return this.currentUser.isSuperAdmin && this.currentUser.id != this.item.id;
    },
    couldEditSuperAdmin() {
      return this.currentUser.isSuperAdmin && this.currentUser.id === this.item.id; // You cannot change your own status
    },
    errorMessage: {
      get() {
        return this.message;
      },
      set(value) {
        if (value === null) {
          this.message = null;
        } else {
          this.message = {
            content: value,
            type: ALERT_TYPE.ERROR,
          };
        }
      },
    },
  },

  created() {
    this.editItem = { ...this.item };
  },

  methods: {
    close() {
      this.$store.dispatch('users/get', {
        ids: this.item.id,
        includeRoles: true,
        includePermissions: true,
        detailedPermissions: true,
      });
      this.$store.commit('users/close', MODAL_NAME.SECURITY_DETAILS);
    },
    edit() {
      if (this.isValidating) return;
      this.errorMessage = null;
      this.isValidating = true;

      const isValid = document.querySelector('#user-security').reportValidity();
      if (isValid) {
        if (this.$refs.toggleAdmin && this.canEditSuperAdmin) this.editItem.isSuperAdmin = this.$refs.toggleAdmin.get();
        this.editItem.isEnabled = this.$refs.toggleEnable.get();
        this.$store
          .dispatch('users/edit', [this.editItem])
          .then(() => {
            this.close();
          })
          .catch((err) => {
            console.error(err);
            if (err && err.status && err.status === 401) {
              this.errorMessage = MESSAGES.NO_PERMISSION;
            } else {
              this.errorMessage = MESSAGES.SERVER_ERROR;
            }
          })
          .finally(() => (this.isValidating = false));
      } else {
        this.isValidating = false;
      }
    },
  },
};
</script>